import React, { useState, useEffect } from 'react';
const ButtonClickLandingPage = () => {
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [loading, setLoading] = useState(true);  
  const [userInfo, setUserInfo] = useState({
    ip: null,
    timezone: null,
    clickedOn: null,
    location: null
  });
  const [dataFetched, setDataFetched] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const mailLogId = queryParams.get('MId');
  const buttonId = queryParams.get('ButtonId');
  const apiUrl = process.env.REACT_APP_API_URL;
  // Fetch all user data at once
  useEffect(() => {
    const fetchUserData = async () => {
      if (dataFetched) return;
      try {
        // Get IP address
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        const ipData = await ipResponse.json();
        const userIp = ipData.ip;
        // Get location based on IP
        const geoResponse = await fetch(`https://ipinfo.io/${userIp}/json`);
        const locationData = await geoResponse.json();
        // Set current time
        const curdate = new Date();
        const userLocalTime = curdate.toISOString();
        // Update all user information at once
        setUserInfo({
          ip: userIp,
          timezone: locationData.timezone || 'N/A',
          clickedOn: userLocalTime,
          location: locationData
        });
      } catch (error) {
        console.error('Error fetching user data:', error);
        setLoading(false);
      }
    };
    fetchUserData();
  }, [dataFetched]);
  // Process button click data only when all needed info is available
  useEffect(() => {
    const processButtonClick = async () => {
      // Only proceed if we have all the necessary data and haven't already fetched
      if (
        dataFetched || 
        !buttonId || 
        !mailLogId || 
        !userInfo.ip || 
        !userInfo.location || 
        !userInfo.timezone || 
        !userInfo.clickedOn
      ) {
        return;
      }
      try {
        setDataFetched(true);
        // Log for debugging
        console.log("=== DEBUG INFO ===");
        console.log("User IP:", userInfo.ip);
        console.log("User Location:", userInfo.location);
        console.log("User Timezone:", userInfo.timezone);
        console.log("Clicked On:", userInfo.clickedOn);
        console.log("Mail Log ID:", mailLogId);
        console.log("Button ID:", buttonId);
        const requestBody = {
          MailLogId: mailLogId,
          ButtonId: buttonId,
          UserIP: userInfo.ip,
          UserTimezone: userInfo.timezone,
          ClickedOn: userInfo.clickedOn,
          UserLocation: userInfo.location
        };
        console.log("Request Payload:", JSON.stringify(requestBody, null, 2));
        // Track button click
        const clickCountResponse = await fetch(
          `${apiUrl}/mailer/TrackButtonClickCount`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
          }
        );
        console.log("Click Count Response Status:", clickCountResponse.status);
        if (!clickCountResponse.ok) {
          throw new Error(`Error tracking button click: ${clickCountResponse.statusText}`);
        }
        // Get button URL
        const buttonUrlResponse = await fetch(
          `${apiUrl}/mailer/GetButtonURL?MailLogId=${mailLogId}&ButtonId=${buttonId}`
        );
        console.log("Button URL Response Status:", buttonUrlResponse.status);
        if (!buttonUrlResponse.ok) {
          throw new Error(`Error fetching button URL: ${buttonUrlResponse.statusText}`);
        }
        const buttonUrlData = await buttonUrlResponse.json();
        console.log("Button URL Data:", buttonUrlData);
        if (buttonUrlData && buttonUrlData.url) {
          setRedirectUrl(buttonUrlData.url);  
        } else {
          console.error("Invalid URL data received:", buttonUrlData);
          setLoading(false);
        }
      } catch (error) {
        console.error('Error processing button click:', error);
        setLoading(false);
      }
    };
    processButtonClick();
  }, [userInfo, buttonId, mailLogId, apiUrl, dataFetched]);

  useEffect(() => {
    if (redirectUrl) {
      console.log('Redirecting to:', redirectUrl);
      window.location.href = redirectUrl;
    }
  }, [redirectUrl]);
  // Set loading to false if we have all user data but no redirect URL yet
  useEffect(() => {
    if (userInfo.ip && userInfo.location && !redirectUrl && dataFetched) {
      setLoading(false);
    }
  }, [userInfo, redirectUrl, dataFetched]);
  if (loading) {
    return <div>Loading...</div>;  
  }
  return null;
};
export default ButtonClickLandingPage;